// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"eb76a193","453":"b5ee7b1b"}[chunkId] + ".chunk.js";
};